import { Component, OnInit} from '@angular/core';
import {ModalDialogV3} from '../../../../../shared-modal-dynamic/models/modal-dialog-v3';

@Component({
  selector: 'app-r-price-info-modal',
  templateUrl: './r-price-info-modal.component.html',
  styleUrls: ['./r-price-info-modal.component.scss']
})
export class RPriceInfoModalComponent  extends ModalDialogV3 implements OnInit {

    public model: {
        title: string,
        msgRows: string[],
        top: string,
        right: string,
        showCloseBtn: true,
        minHeight: number,
    };



    constructor() {
        super();
    }

    ngOnInit() {
        this.model = <{ title: string,  msgRows: string[], top: string,
            right: string, showCloseBtn: true, minHeight: number, }> this.modalParams.model;
    }

    onCloseBtnClicked() {
        super.close();
    }
}
